import client from "./client";

const feeTransactionsApi = {
  recordPayment(body) {
    return client.post("/fee-transactions", body).then((r) => r.data);
  },

  refund(id, body) {
    return client.post(`/fee-transactions/${id}/refund`, body).then((r) => r.data);
  },

  getByStudent(studentId, params = {}) {
    return client.get(`/fee-transactions/student/${studentId}`, { params }).then((r) => r.data);
  },

  getBySchool(params = {}) {
    return client.get("/fee-transactions/school", { params }).then((r) => r.data);
  },

  getDailySummary(params = {}) {
    return client.get("/fee-transactions/daily-summary", { params }).then((r) => r.data);
  },
};

export default feeTransactionsApi;
